import React from 'react';
import { Button } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import styles from './change-password.module.scss';

const ChangePassword = ({ onSubmit, isValid }) => (
  <form onSubmit={onSubmit} autoComplete="off">
    <div className={styles.changePassword}>
      <div className={styles.name}>Изменить пароль</div>
      <div className={styles.fields}>
        <div className={styles.field}>
          <Input
            label="Старый пароль"
            name="oldPassword"
            type="password"
            placeholder="Введите старый пароль"
          />
        </div>
        <div className={styles.field}>
          <Input
            label="Новый пароль"
            name="password"
            type="password"
            placeholder="Придумайте новый пароль"
          />
        </div>
        <div className={styles.field}>
          <Input
            label="Повторите пароль"
            name="confirmPassword"
            type="password"
            placeholder="Повторно введите новый пароль"
          />
        </div>
      </div>
    </div>
    <Button
      type="submit"
      color="lightgray"
      disabled={!isValid}
    >
      Изменить пароль
    </Button>
  </form>
);

export default ChangePassword;
